import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function OpHeader({ title }) {
  const nav = useNavigate();
  return (
    <div className="flex items-center gap-3 mb-5">
      <button onClick={() => nav("/operasional-jahitan")} className="p-2 rounded-full hover:bg-slate-100 text-slate-600" data-testid="op-back-btn"><ArrowLeft className="w-5 h-5" /></button>
      <h1 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">{title}</h1>
    </div>
  );
}
